import React from "react"
import { isEqual } from "lodash-es"
import { useDispatch, useSelector } from "react-redux"
import { getCategories, getCategorySlugs } from "reduxSlices/categoriesSlice"
import { deselectAllCategories, selectAllCategories } from "reduxSlices/reportIndexSlice"
import MassSelection from "shared/MassSelection"
import { SidebarCollapsibleContent } from "shared/Sidebar"
import ReportIndexSidebarSolutionSectionSolutionCheckbox from "./ReportIndexSidebarSolutionSectionSolutionCheckbox"

const ReportIndexSidebarSolutionSection = () => {
  const dispatch = useDispatch()

  const categories = useSelector(getCategories, isEqual)
  const categorySlugs = useSelector(getCategorySlugs, isEqual)

  const selectAll = () => dispatch(selectAllCategories())
  const deselectAll = () => dispatch(deselectAllCategories({ slugs: categorySlugs }))

  return (
    <SidebarCollapsibleContent title="Solutions">
      <MassSelection className="mb-4" selectAll={selectAll} deselectAll={deselectAll} />
      {
        categories.map(({ name, slug }) => (
          <ReportIndexSidebarSolutionSectionSolutionCheckbox
            key={slug}
            categoryName={name}
            categorySlug={slug}
          />
        ))
      }
    </SidebarCollapsibleContent>
  )
}

export default ReportIndexSidebarSolutionSection
